import { type ActorRefFromLogic } from "xstate";

import { LOCAL_WORKSPACE_NAME } from "~/strings";

import { docsApi } from "../../api/docsapi";
import { type AuthenticationMachine, waitForAccessTokenSilently } from "../authentication";

export const hasSharePermissionPromise = async ({
	input,
}: {
	input: {
		documentId: string;
		publishWorkspace: string | undefined;
		authenticationActorRef: ActorRefFromLogic<AuthenticationMachine>;
	};
}): Promise<boolean> => {
	const { documentId, publishWorkspace, authenticationActorRef } = input;
	if (!publishWorkspace) {
		return false;
	}

	const token = await waitForAccessTokenSilently(authenticationActorRef);
	if (!token) {
		return false;
	}

	if (publishWorkspace === LOCAL_WORKSPACE_NAME) {
		return false;
	}

	return await docsApi.document.permissions.check({
		token,
		workspaceName: publishWorkspace,
		documentId,
		permission: "share",
	});
};
